import { useCallback } from 'react';
import { useLocalStorage } from 'react-use';

import { trackEvent } from '@surfline/web-common';

export const BAR = 'BAR';
export const LINE = 'LINE';
export const LOCAL_STORAGE_KEY = 'liveWindModalGraph';

const useStoredGraphToggle = () => {
  const [graph, setGraph] = useLocalStorage(LOCAL_STORAGE_KEY, BAR);

  const toggleGraph = useCallback(() => {
    const isBarGraph = graph === BAR;
    trackEvent('Clicked Toggle', {
      toggleType: 'live wind graphs',
      toggleStart: isBarGraph ? 'live-wind-bar' : 'live-wind-line',
      toggleEnd: isBarGraph ? 'live-wind-line' : 'live-wind-bar',
    });

    if (isBarGraph) {
      return setGraph(LINE);
    }
    return setGraph(BAR);
  }, [setGraph, graph]);

  return { graph, setGraph, toggleGraph };
};

export default useStoredGraphToggle;
